var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header_collapse_work_time"},[_c('HeaderMainMode')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }